module.exports = __webpack_public_path__ + "img/jackpot.e6d4e9d9.png";